export const useSessionStorage = (key: string) => ({
	value: sessionStorage.getItem(key),
	remove: () => sessionStorage.removeItem(key),
	set: (value: string) => sessionStorage.setItem(key, value),
	equalsTo: (value: string) => sessionStorage.getItem(key) === value,
	has: (value: string) => !!sessionStorage.getItem(key)?.includes(value),
});
